<section
  *transloco="let t"
  class="email-phone-sign-in-container"
  [class.error]="submitted && !loading && failed"
  [class.ios-app]="redirect">
  <!-- EMAIL OR PHONE SIGN IN -->
  @if (otpRequestedResults() === null) {
    <span class="fixed-space-24" aria-hidden="true"></span>

    <form class="form" name="email-phone-sign-in">
      @if (!submitted) {
        @if (lang === 'en') {
          <h1 class="title">Let’s get you started.</h1>
          <p class="subtitle">
            Enter your phone number or email to create an account or to login into an
            existent account.
          </p>
        } @else {
          <h1 class="title">لنبدأ.</h1>
          <p class="subtitle">
            أدخل رقم هاتفك أو بريدك الإلكتروني لإنشاء حساب أو لتسجيل الدخول إلى حساب
            موجود.
          </p>
        }

        <div class="form-field" floatLabel="always" shouldLabelFloat hideRequiredMarker>
          @if (formValueMode() === 'email') {
            <popsy-input
              class="label"
              data-clarity-unmask
              autocomplete="email"
              [value]="formValue()"
              [placeholder]="
                lang === 'en' ? 'Email or Phone Number' : 'الإيميل أو الهاتف'
              "
              [autofocus]="keepFocus()"
              (focusChange)="keepFocus.set(true)"
              (valueChange)="onFormValueChange($event)"></popsy-input>
          } @else {
            <popsy-phone-input
              class="phone-input"
              data-clarity-unmask
              [type]="'numeric'"
              [value]="{
                countryCode: '',
                areaCode: '',
                national: formValue(),
                display: ''
              }"
              [country]="defaultCountryCode()"
              [autofocus]="keepFocus()"
              (focusChange)="keepFocus.set(true)"
              (debouncedPhoneNumberChange)="onFormValueChange($event)" />
          }

          <span
            class="error"
            *ngIf="this.logInputFormControl.hasError('required') && submitted">
            {{ t('error_email_required') }}
          </span>
          <span class="error" *ngIf="this.logInputFormControl.hasError('email')">
            {{ t('error_email_not_valid') }}
          </span>
          <span class="error" *ngIf="this.logInputFormControl.hasError('USER_NOT_FOUND')">
            {{ t('error_login_does_not_exist') }}
          </span>
          <span class="error" *ngIf="this.logInputFormControl.hasError('USER_BANNED')">
            {{ t('error_login_does_not_exist') }}
          </span>
        </div>
      }
      @if (submitted) {
        <h2 class="title">{{ t('title_welcome') }}</h2>
        <span class="fixed-space-24" aria-hidden="true"></span>

        <div class="confirm">
          <popsy-icon-envelope class="icon fill-gray-dark" aria-hidden="true" />
          @if (lang === 'en') {
            <p>
              <strong>Please check your inbox</strong> and click the confirmation link we
              just sent. Once you confirm, return to this window.
            </p>
          } @else {
            <p>
              <strong>الرجاء التحقق من بريدك الإلكتروني</strong> وانقر على رابط التأكيد
              الذي أرسلناه للتو. بمجرد التأكيد، عد إلى هذه النافذة.
            </p>
            <span class="fixed-space-24" aria-hidden="true"></span>
            <p>
              لم تتلقَ بريدًا إلكترونيًا؟ تأكد من التحقق من مجلد البريد العشوائي أو
              المهملات أيضًا.
            </p>
          }
        </div>

        @if (lang === 'en') {
          <span class="fixed-space-24" aria-hidden="true"></span>

          <p class="text-gray-dark text-align-center full-width">
            Didn’t get an email? Make sure to check your spam or junk folder too.
          </p>

          <div class="text-gray-dark text-align-center full-width">
            Having trouble? Create account with
          </div>
          <div
            class="text-gray-dark text-align-center underlined full-width cursor-pointer"
            (click)="goBack()">
            phone number.
          </div>
        } @else {
          <span class="fixed-space-24" aria-hidden="true"></span>

          <div class="text-gray-dark text-align-center full-width">
            هل تواجه مشكلة؟ إنشاء حساب باستخدام
          </div>
          <div
            class="text-gray-dark text-align-center underlined full-width cursor-pointer"
            (click)="goBack()">
            رقم الهاتف.
          </div>
        }
      }
    </form>
    @if (!submitted) {
      <button
        class="button popsy-button-primary blue-button"
        [class.error]="submitted && failed"
        [class.disabled]="loading || submitted"
        [class.success]="submitted && success"
        (click)="submitEmailPhoneValue()">
        <app-loading class="spinner" *ngIf="loading"></app-loading>
        <span *ngIf="!loading" class="message">{{ t('action_continue') }}</span>
      </button>
    }
  }
  <!-- OTP -->
  @if (otpRequestedResults() !== null) {
    <span class="fixed-space-24" aria-hidden="true"></span>

    <h2 class="title">{{ t('title_welcome') }}</h2>
    <span class="fixed-space-24" aria-hidden="true"></span>
    <label>
      @if (lang === 'en') {
        <h4 class="text-gray-05">
          {{
            'Please enter the OTP (One Time password) sent to the registered mobile number ' +
              logInputFormControl.value
          }}
        </h4>
      } @else {
        <h4 class="text-gray-05">
          {{
            'الرجاء إدخال OTP (كلمة المرور لمرة واحدة) المرسلة إلى رقم الهاتف المسجل ' +
              logInputFormControl.value
          }}
        </h4>
      }
    </label>

    <form class="form">
      <span class="fixed-space-8" aria-hidden="true"></span>

      <input class="otp full-width" [formControl]="otpForm" placeholder="123456" />

      <div aria-hidden="true" class="dynamic-space"></div>

      <button
        (click)="confirmCode()"
        class="popsy-button-primary blue-button"
        [disabled]="loading">
        @if (lang === 'en') {
          <span> Verify OTP</span>
        } @else {
          <span> تحقق من OTP</span>
        }
      </button>

      <!-- REQUEST ANOTHER OTP -->
      @if (requestingAgainCounterdown() > 0) {
        <span class="fixed-space-8" aria-hidden="true"></span>

        <span class="margin-0-auto"> {{ t('label_resend_sms') }}</span>

        <div class="flex flex-row gap-4 align-center justify-center margin-0-auto">
          @if (lang === 'en') {
            <span class="text-gray-dark text-align-center full-width"> Resend OPT </span>
          } @else {
            <span class="text-gray-dark text-align-center full-width">
              إعادة إرسال OTP
            </span>
          }
          @if (requestingAgainCounterdown()) {
            <span class="fixed-space-8" aria-hidden="true"></span>|
            <span class="fixed-space-8" aria-hidden="true"></span>
            <span>{{ requestingAgainCounterdown() }}</span>
          }
        </div>
      }
      <span class="fixed-space-16" aria-hidden="true"></span>

      @if (requestingAgainCounterdown() === 0) {
        @if (lang === 'en') {
          <span
            (click)="submitEmailPhoneValue()"
            class="text-gray-dark text-align-center underlined full-width cursor-pointer">
            Resend OPT
          </span>
        } @else {
          <span
            (click)="submitEmailPhoneValue()"
            class="text-gray-dark text-align-center underlined full-width cursor-pointer">
            إعادة إرسال OTP
          </span>
        }
      }
      <span class="fixed-space-16" aria-hidden="true"></span>

      @if (lang === 'en') {
        <div class="text-gray-dark text-align-center full-width">
          Having trouble? Create account with
        </div>
        <div
          class="text-gray-dark text-align-center underlined full-width cursor-pointer"
          (click)="goBack()">
          another phone number.
        </div>
      } @else {
        <div class="text-gray-dark text-align-center full-width">
          هل تواجه مشكلة؟ إنشاء حساب باستخدام
        </div>

        <div
          class="text-gray-dark text-align-center underlined full-width cursor-pointer"
          (click)="goBack()">
          رقم هاتف آخر.
        </div>
      }
    </form>
  }

  <div
    #recaptchaContainer0
    id="recaptchaContainer0"
    style="width: 0; height: 0; opacity: 0; position: absolute"></div>
  <div
    #recaptchaContainer1
    id="recaptchaContainer1"
    style="width: 0; height: 0; opacity: 0; position: absolute"></div>
  <div
    #recaptchaContainer2
    id="recaptchaContainer2"
    style="width: 0; height: 0; opacity: 0; position: absolute"></div>
</section>
